import {
  UPLOAD_BULK_TRANSACTION_ERROR,
  UPLOAD_BULK_TRANSACTION_START,
  UPLOAD_BULK_TRANSACTION_SUCCESS,
} from 'constants/action-types/groups/uploadBulkTransaction';

export default (state, { type, payload }) => {
  switch (type) {
    case UPLOAD_BULK_TRANSACTION_START:
      return {
        ...state,
        bulkTransactionUpload: {
          ...state.bulkTransactionUpload,
          loading: true,
          error: null,
        },
      };
    case UPLOAD_BULK_TRANSACTION_ERROR:
      return {
        ...state,
        bulkTransactionUpload: {
          ...state.bulkTransactionUpload,
          error: payload,
          loading: false,
        },
      };
    case UPLOAD_BULK_TRANSACTION_SUCCESS:
      return {
        ...state,
        bulkTransactionUpload: {
          ...state.bulkTransactionUpload,
          loading: false,
          error: null,
          data: payload,
        },
      };
    default:
      return null;
  }
};
